var site = window.site || {};

(function ($) {
  Drupal.behaviors.productAddToBagV1 = {
    backOrderEnabled: Drupal.settings.elc_ecom.prodcatConfig.backorder.enabled,
    attach: function () {
      var self = this;
      var $modules;

      if (self.attached) {
        return;
      }
      self.attached = true;
      $modules = $('.js-product-add-to-bag-wrapper', document);
      self.addToBagSetup($modules, true);

      // For dynamically generated uses of this partial which get added to DOM after page load.
      $(document).on('product_partial:product_reinit', function (e) {
        var $el = e.payload['$el'];

        $modules = $el.find('.js-product-add-to-bag-wrapper');
        self.addToBagSetup($modules, true);
      });

      $(document).on('product_partial:atb_status_change', function (e) {
        var $el = e.payload['$el'];
        var payloadStatus = e.payload['status'];

        self.addToBagSetup($el, false, payloadStatus);
      });
    },
    addToBagSetup: function ($modules, includeListener, payloadstatus) {
      var self = this;

      $modules.each(function () {
        var $module = $(this);

        self.getDom($module);
        self.setInits($module, payloadstatus);
        if (includeListener) {
          self.setAtbListener($module);
        }
      });
    },
    getDom: function ($module) {
      $module.nodes = {
        status: $module.siblings('.js-product-add-to-bag-status'),
        atb: $('.js-product-add-to-bag', $module)
      };
    },
    setInits: function ($module, updatedStatus) {
      var skuStatus = updatedStatus ? updatedStatus : $module.nodes.atb.data('inventoryStatus');
      // Previously var label = site.translations.elc_product.temp_out_of_stock;.
      var label = site.translations.product.add_to_bag;
      var message = '';
      var disabled = false;

      if (skuStatus === '7' || skuStatus === 'Sold Out') {
        label = site.translations.elc_product.sold_out;
        message = site.translations.elc_product.item_is_sold_out;
        disabled = true;
      }

      if (skuStatus === '2' || skuStatus === 'Temporarily out of stock') {
        label = site.translations.elc_product.temp_out_of_stock;
        message = site.translations.elc_product.temp_out_of_stock_title;
        if (!self.backOrderEnabled) {
          disabled = true;
        }
      }

      if (skuStatus === '3' || skuStatus === 'Coming Soon') {
        label = site.translations.elc_product.coming_soon;
        message = site.translations.elc_product.item_is_coming_soon_notify_me;
        disabled = true;
      }

      $module.nodes.atb.html(label);
      $module.nodes.status.html(message);
      disabled ? $module.addClass('disabled') : $module.removeClass('disabled');
    },
    setAtbListener: function ($module) {
      $module.nodes.atb.off('click.addToBag').on('click.addToBag', function (e) {
        e.preventDefault();
        var $addToBagBtn = $(this);
        var payload = {};
        var skuBaseId = parseInt($addToBagBtn.attr('data-sku-base-id'));

        payload.quantity = 1;
        payload.replenishment = false;

        $(document).trigger('perlgem.cart.addItem', [skuBaseId, payload]);
      });
    },
    attached: false
  };
})(jQuery);
